import {
  Box,
  Button,
  CardContent,
  Grid,
  makeStyles,
  TextField,
} from '@material-ui/core';
import html2canvas from 'html2canvas';
import { Search, Pageview } from '@material-ui/icons';
import { toast } from 'react-toastify';
import { Autocomplete } from '@material-ui/lab';
import { localizationTable, options } from 'constants/table';
import MaterialTable, { MTableToolbar } from 'material-table';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CertificateData, EnrollmentData, ModuleData } from 'services/dataService';
import theme from 'theme';
import FileSaver from 'file-saver';
import { useSelector } from 'react-redux';
import { format, parseISO, isValid } from 'date-fns';

const StudentCertificates = () => {
  const { control, handleSubmit, setValue } = useForm({
    defaultValues: { searchData: '123' },
  });
  const { t } = useTranslation(['form', 'tables', 'button']);
  const { id, id_company } = useSelector((state) => state.auth);
  const classes = useStyles();

  const [searchField, setSearchField] = React.useState([]);
  const [searchValue, setSearchValue] = React.useState('');
  const [modules, setModules] = useState([]);
  const [arrayLesson, setArrayLesson] = useState([]);
  const [data, setData] = useState();
  const [loading, setLoading] = useState();
  const tableRef = React.useRef();

  const onSubmit = React.useCallback(({ searchData }) => {
    setSearchValue(searchData?.id_company_course);
  });

  const getData = async (filter) => {
    setLoading(true);
    const response =  await EnrollmentData.getUserCompletedCourses(id, searchValue); 
    const { fields, results } = response?.data;
  
    const combinedData = [...results];
  
    setSearchField(fields || []);
    setData(combinedData);
    setLoading(false);
  }
  useEffect(() => {
    getData();
  }, [searchValue]);

  const handleDownloadCertificate = useCallback(async (rowData) => {
    try {
      toast.success(t('toastify:commons.toast_success_certificate'));
      const response = await ModuleData.getModuleByIdCourse(rowData?.id_course);
      const arrayModule = response.data.modules
        .sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0))
        .map((module, index) => {
          return {
            index,
            id: module?.id || null,
            title: module.title,
          };
        });

      const arrayLes = response.data.modules.map((module) => {
        return module.lessons.map((lesson) => {
          return {
            id_lesson: lesson.id,
            id_course: lesson.id_course,
            id_module: lesson.id_module,
            title: lesson.title,
          };
        });
      });

      setModules(arrayModule);
      setArrayLesson(arrayLes.flat());

      const secondPageCanvas = await html2canvas(document.getElementById('certificate-second-page'), {
        scale: 2,
        useCORS: true,
      });
      const secondPageImage = secondPageCanvas.toDataURL('image/png');

      const requestBody = {
        id_enrollment: rowData?.id_enrollment,
        id_user: id,
        certificate_create_date: rowData?.certificateCreation,
        secondPageImage,
      };

      const { data: base64CertificateFile } = await CertificateData.download(
        rowData?.id_company_course,
        requestBody
      );

      const responsePDF = await fetch(base64CertificateFile);
      const blob = await responsePDF.blob();
      FileSaver.saveAs(blob, `${rowData?.name}.pdf`);

    } catch (error) {
      console.error('Erro ao gerar o certificado:', error);
    }
  }, []);

    const columns = useMemo(() => {
      const maxHeight = 520; 
      const estModuleTitle = 24;
      const estLesson = 16;
    
      const colLimit = 3;
      const colList = Array.from({ length: colLimit }, () => []);
      let currentHeight = 0;
      let colIndex = 0;
    

      let totalLessonsCount = 0;
      const maxTotalLessons = 50; 
    
      for (const module of modules) {
        if (totalLessonsCount >= maxTotalLessons) break;
    
        const lessons = arrayLesson
          .filter(lesson => lesson.id_module === module.id)
          .slice(0, maxTotalLessons - totalLessonsCount);
    
        if (lessons.length === 0) continue;
    
        const estHeight = estModuleTitle + lessons.length * estLesson;
    
        if (currentHeight + estHeight > maxHeight && colIndex < colLimit - 1) {
          colIndex++;
          currentHeight = 0;
        }
    
        colList[colIndex].push({ ...module, lessons });
        currentHeight += estHeight;
        totalLessonsCount += lessons.length;
      }
    
      return colList;
    }, [modules, arrayLesson]);

  return (
    <>
      <div
        id="certificate-second-page"
        style={{
          position: 'absolute',
          top: '-9999px',
          left: '-9999px',
          width: '1366px',
          height: '768px',
          padding: '25px',
          boxSizing: 'border-box',
          background: '#fff',
          fontFamily: 'Arial, sans-serif',
          fontSize: '16px',
          color: '#000',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <h2 style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: '20px',  marginLeft: '20px' }}>
            Conteúdo Programático
          </h2>

          <div style={{ display: 'flex', gap: '40px' }}>
            {columns.map((col, idx) => (
              <div key={idx} style={{ flex: 1 }}>
                {col.map((module, i) => (
                  <div key={i} style={{ marginBottom: '20px', breakInside: 'avoid' }}>
                    <strong style={{ display: 'block', marginBottom: '4px' }}>
                      {module.title}
                    </strong>
                    {module.lessons.map((lesson, j) => (
                      <div key={j} style={{ fontSize: '14px', lineHeight: '1.6', marginLeft: '10px' }}>
                        Aula {lesson.order?.toString().padStart(2, '0')} – {lesson.title}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
        </div>
      </div>
    <Box className={classes.root}>
     <MaterialTable
        isLoading={loading}
        title={`${t('tables:Certificate.title')}`}
        tableRef={tableRef}
        columns={[
          {
            title: t('tables:Certificate.name_column'),
            field: 'name',
            render: (rowData) => (
              <p
                style={{ color: '#176AE6', cursor: 'pointer' }}
                onClick={(_, event) => handleDownloadCertificate(rowData)}
              >
                {rowData?.name || rowData?.company_course?.course?.name}
              </p>
            ),
          },
          {
            title: t('tables:Certificate.date_emission_column'),
            field: 'certificateCreation',
            type: 'date',
            render: (rowData) => {
              const certificateDate = rowData?.certificateCreation ? parseISO(rowData.certificateCreation) : rowData?.finished_at ? parseISO(rowData.finished_at) : null;
        
            return certificateDate && isValid(certificateDate)
              ? format(certificateDate, 'dd/MM/yyyy - HH:mm')
              : 'N/A';
          }
          },
          {
            title: t('tables:Certificate.grade_column'),
            field: 'score',
            render: (rowData) => (
              <span>{parseFloat(rowData?.score).toFixed(2)} %</span>
            ),
          },
        ]}
          data={data}
          components={{
            search: false,
            Toolbar: (props) => (
              <div>
                <MTableToolbar {...props} />
                <form onSubmit={handleSubmit(onSubmit)}>
                  <CardContent>
                    <Grid
                      container
                      spacing={1}
                      direction="row"
                      alignItems="center"
                    >
                      <Grid item md={7} xs={6}>
                        <Controller
                          as={
                            <Autocomplete
                              fullWidth
                              clearOnEscape
                              id="combo-box-demo"
                              options={searchField || []}
                              getOptionLabel={(option) => option?.name || ''}
                              onChange={(_, value) => {
                                setValue('searchData', value?.id)
                              }
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  margin="normal"
                                  label={t('form:commons.input_search')}
                                  variant="outlined"
                                />
                              )}
                            />
                          }
                          onChange={(data) => data[1]}
                          control={control}
                          name="searchData"
                        />
                      </Grid>
                      <Grid item md={3} xs={1} />
                      <Grid item md={2} xs={5} className={classes.actions}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="contained"
                          size="large"
                          type="submit"
                        >
                          <Search style={{ marginRight: 8 }} />
                          {t('button:User_solictation.btn_advanced_filter')}
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </form>
              </div>
            ),
          }}
          localization={localizationTable(t, {
            emptyDataSourceMessage: 'tables:Certificate.empty_data',
            actions: 'button:commons.btn_download',
          })}
          options={{ ...options, emptyRowsWhenPaging: false }}
          actions={[
            {
              hidden: true,
            },
            {
              icon: 'download',
              tooltip: `Baixar certificado`,
              onClick: (_, rowData) => handleDownloadCertificate(rowData),
            },
            {
              icon: ()=> <Pageview style={{color: '#176AE6' }} />,
              tooltip: `${t('button:Course.btn_validate_certificate')}`,
              onClick: (event, rowData) => {
                window.open(`/validate/${rowData.id_company_course}/${rowData.id_enrollment}/certificate`,'_blank');
              },  
            }
          ]}
        />
      </Box>
  </>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
}));

export default React.memo(StudentCertificates);
